import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../api/axios';
import Layout from '../../components/layout/Layout';

function formatTime(dt) {
  if (!dt) return '—';
  return new Date(dt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export default function StaffDashboard() {
  const { user } = useAuth();
  const [today, setToday] = useState(null);
  const [recent, setRecent] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      try {
        const [todayRes, histRes] = await Promise.all([
          api.get('/attendance/today'),
          api.get('/attendance/my-history?limit=5'),
        ]);
        setToday(todayRes.data.attendance);
        setRecent(histRes.data.attendance);
      } catch {}
      setLoading(false);
    }
    load();
  }, []);

  if (loading) return <Layout><div style={{ textAlign: 'center', padding: '3rem' }}><span className="spinner spinner-dark" /></div></Layout>;

  const now = new Date();

  return (
    <Layout>
      <div className="page-header">
        <h1>Welcome back, {user?.full_name?.split(' ')[0]} 👋</h1>
        <p>{now.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</p>
      </div>

      {/* Today's status */}
      <div className="card" style={{ marginBottom: '1.5rem' }}>
        <h2 style={{ fontSize: '1rem', fontWeight: 600, marginBottom: '1rem', color: '#475569' }}>TODAY'S ATTENDANCE</h2>
        {!today ? (
          <div style={{ textAlign: 'center', padding: '1.5rem' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>📍</div>
            <p style={{ color: '#64748b', marginBottom: '1rem' }}>You haven't signed in today yet.</p>
            <Link to="/attendance" className="btn btn-primary btn-lg">Take Attendance Now</Link>
          </div>
        ) : (
          <div>
            <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', marginBottom: '1rem' }}>
              <div style={cardItem}>
                <div style={{ color: '#64748b', fontSize: '0.8rem' }}>SIGN IN</div>
                <div style={{ fontSize: '1.5rem', fontWeight: 700, color: '#16a34a' }}>{formatTime(today.sign_in_time)}</div>
              </div>
              <div style={cardItem}>
                <div style={{ color: '#64748b', fontSize: '0.8rem' }}>SIGN OUT</div>
                <div style={{ fontSize: '1.5rem', fontWeight: 700, color: today.sign_out_time ? '#2563eb' : '#94a3b8' }}>
                  {formatTime(today.sign_out_time)}
                </div>
              </div>
              <div style={cardItem}>
                <div style={{ color: '#64748b', fontSize: '0.8rem' }}>STATUS</div>
                <span className={`badge badge-${today.status}`}>{today.status}</span>
              </div>
            </div>
            {!today.sign_out_time && (
              <Link to="/attendance" className="btn btn-primary">Sign Out Now →</Link>
            )}
          </div>
        )}
      </div>

      {/* Staff info card */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1rem', marginBottom: '1.5rem' }}>
        <div className="card">
          <h3 style={{ fontSize: '0.85rem', color: '#64748b', fontWeight: 600, marginBottom: '0.75rem' }}>MY PROFILE</h3>
          <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
            <div style={{ width: 48, height: 48, borderRadius: '50%', background: '#dbeafe', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.25rem', fontWeight: 700, color: '#2563eb' }}>
              {user?.full_name?.charAt(0)}
            </div>
            <div>
              <div style={{ fontWeight: 600 }}>{user?.full_name}</div>
              <div style={{ color: '#64748b', fontSize: '0.8rem' }}>{user?.staff_id} • {user?.department}</div>
            </div>
          </div>
        </div>

        <div className="card" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <Link to="/attendance" className="btn btn-primary btn-block" style={{ marginBottom: '0.5rem' }}>📷 Take Attendance</Link>
          <Link to="/history" className="btn btn-secondary btn-block">📋 View My History</Link>
        </div>
      </div>

      {/* Recent records */}
      {recent.length > 0 && (
        <div className="card">
          <h2 style={{ fontSize: '1rem', fontWeight: 600, marginBottom: '1rem', color: '#475569' }}>RECENT ATTENDANCE</h2>
          <div className="table-wrap">
            <table>
              <thead>
                <tr><th>Date</th><th>Sign In</th><th>Sign Out</th><th>Status</th></tr>
              </thead>
              <tbody>
                {recent.map(r => (
                  <tr key={r.id}>
                    <td>{new Date(r.date).toLocaleDateString()}</td>
                    <td>{formatTime(r.sign_in_time)}</td>
                    <td>{formatTime(r.sign_out_time)}</td>
                    <td><span className={`badge badge-${r.status}`}>{r.status}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={{ marginTop: '1rem' }}>
            <Link to="/history" style={{ color: '#2563eb', fontSize: '0.875rem', fontWeight: 500 }}>View all records →</Link>
          </div>
        </div>
      )}
    </Layout>
  );
}

const cardItem = {
  background: '#f8fafc',
  borderRadius: 10,
  padding: '0.875rem 1.25rem',
  minWidth: 110,
};
